
export class WorkflowTest {
    workflow_template_id: number;
    input: any;
    assert_script: string;
    company_id: number;
    id?: number;
    name?: string;
    description?: string;
    state?: string;
    last_run?: string;
    passed?: boolean;
    errors?: Array<string>;
    output?: any;

    constructor(
      workflow_template_id: number,
      input: any,
      assert_script: string,
      company_id: number,
      id?: number,
      name?: string,
      description?: string,
      state?: string,
      last_run?: string,
      passed?: boolean,
      errors?: Array<string>,
      output?: any
    ) {
      this.workflow_template_id = workflow_template_id;
      this.input = input;
      this.assert_script = assert_script;
      this.company_id = company_id;
      this.id = id;
      this.name = name;
      this.description = description;
      this.state = state;
      this.last_run = last_run;
      this.passed = passed;
      this.errors = errors;
      this.output = output;
    }

    static createEmpty() {
        return new WorkflowTest(
            0,
            {},
            "",
            0,
            undefined,
            undefined,
            "",
            undefined,
            undefined,
            undefined,
            [],
            undefined
        );
    }
  }
  